import { Fade, Zoom } from "react-reveal";
import desoIcon from "../../images/Svg/homepage/working/deso.png";
import diamondIcon from "../../images/Svg/homepage/working/diamond.png";
import realTimeSyncIcon from "../../images/Svg/homepage/working/realTimeSync.png";
import userIcon from "../../images/Svg/homepage/working/user.png";
const parse = require("html-react-parser");

let workingData = [
  {
    title: "Login with DeSo account",
    icon: desoIcon,
  },
  {
    title: `Login with Social Media`,
    icon: userIcon,
  },
  {
    title: "Sync your Content",
    icon: realTimeSyncIcon,
  },
  {
    title: "Reap web3 benefits",
    // icon: diamondIcon,
  },
];

const Working = () => {
  return (
    <Fade cascade duration={1000}>
      <section
        className={`container mx-auto px-6 sm:px-6 md:px-16 mb-20 mt-10`}
      >
        <div className="text-center">
          <div>
            <h1 className={` Secondheading font-bold text-[#161616]`}>
              How does it work?
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 md:flex mx-auto flex-wrap justify-evenly mt-[40px]">
          {workingData.map((data, index) => (
            <div key={index} className="mb-[32px]  md:mb-2 w-[175px] mx-auto">
              <div
                className={`${
                  index != 3 ? "bg-[#F6F2FF]" : "working_shpae"
                } rounded-[8px] flex items-center mx-auto w-[100%] h-[175px] `}
              >
                {index !== 3 && (
                  <img
                    className="w-[90px] h-[90px] mx-auto"
                    src={data?.icon}
                    alt=""
                  />
                )}
              </div>
              <div className="text-center mt-[16px] md:mt-[24px]">
                <h1 className="text-[20px] md:text-[24px] text-[#000000] font-bold">
                  {data?.title}
                </h1>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Fade>
  );
};

export default Working;
